/**
 * The session marker cookie (COMBI-4521). src/.htaccess redirects Dutch pages to nl.combidesk.com and English ones
 * to combidesk.com, but the user (and the rest of the session, like an installation in progress) lives in
 * localStorage, which is per origin: a redirect to the other host would lose it. So while there is a user in
 * localStorage, this cookie tells Apache to leave the visitor on the current host.
 *
 * It's host-only (no Domain attribute) on purpose: it marks the session on this host, not on the other one.
 * It's kept as long as the localStorage user is (until logout), and refreshed every time the app starts.
 */
export const SESSION_COOKIE_NAME = "cd_session";

const MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

export function syncSessionCookie(hasUser: boolean, doc: Document = document): void {
  const secure = doc.location?.protocol === "https:" ? "; Secure" : "";
  const value = hasUser ? `1; Max-Age=${MAX_AGE_SECONDS}` : "; Max-Age=0";
  doc.cookie = `${SESSION_COOKIE_NAME}=${value}; Path=/; SameSite=Lax${secure}`;
}
